import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from "react";
import type { KeyboardEvent } from "react";
export function useControlledTooltip() {
  const $ = _c(9);
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] !== isOpen) {
    t0 = () => {
      if (!isOpen) {
        return;
      }
      const handleScroll = () => setIsOpen(false);
      window.addEventListener("scroll", handleScroll, {
        passive: true,
        capture: true
      });
      return () => window.removeEventListener("scroll", handleScroll, {
        capture: true
      });
    };
    t1 = [isOpen];
    $[0] = isOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOpen(true);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const open = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(false);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const close = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        setIsOpen(true);
      } else {
        if (e.key === "Escape") {
          setIsOpen(false);
        }
      }
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleKeyDown = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      tabIndex: 0,
      onMouseEnter: open,
      onMouseLeave: close,
      onFocus: open,
      onBlur: close,
      onKeyDown: handleKeyDown
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isOpen) {
    t6 = {
      isOpen,
      setIsOpen,
      triggerProps: t5
    };
    $[7] = isOpen;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}